import { Download } from 'lucide-react';
import { safeFormat } from '@/lib/safeDate';
import { format } from 'date-fns';
import { Button } from '@/components/ui/button';
import type { Expense } from '@/hooks/finance/useExpenses';

interface ExpensesExportProps {
  expenses: Expense[];
  getCategoryName: (id: string | null) => string;
}

export function ExpensesExport({ expenses, getCategoryName }: ExpensesExportProps) {
  const handleExportCSV = () => {
    const headers = ['Descrição', 'Fornecedor', 'Categoria', 'Valor', 'Moeda', 'Vencimento', 'Status', 'Marca', 'Observações'];
    const rows = expenses.map((e) => [
      e.description,
      e.supplier_name || '',
      getCategoryName(e.category_id),
      e.amount.toString(),
      e.currency,
      e.due_date,
      e.status,
      e.brand || '',
      e.notes || '',
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.map((cell) => `"${cell.replace(/"/g, '""')}"`).join(','))
      .join('\n');

    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `contas-a-pagar-${safeFormat(new Date(), 'yyyy-MM-dd')}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Button variant="outline" size="sm" onClick={handleExportCSV}>
      <Download className="h-4 w-4 mr-2" />
      Exportar CSV
    </Button>
  );
}
